import React, { useEffect, createElement } from 'react';
import { useScreenInit } from './useScreenInit';
import { UrgencyBar } from './components/UrgencyBar';
import { SocialProofToast } from './components/SocialProofToast';
import { Hero } from './components/Hero';
import { Manifesto } from './components/Manifesto';
import { WhyReadThis } from './components/WhyReadThis';
import { FiveReasonsHeader } from './components/FiveReasonsHeader';
import { WhatYouLearn } from './components/WhatYouLearn';
import { Dedication } from './components/Dedication';
import { WarningSection } from './components/WarningSection';
import { BookExcerpts } from './components/BookExcerpts';
import { Testimonials } from './components/Testimonials';
import { FourReasons } from './components/FourReasons';
import { PricingGuarantee } from './components/PricingGuarantee';
import { FAQ } from './components/FAQ';
import { Footer } from './components/Footer';
const META_PIXEL_ID = '1673165833732305';
export function App() {
  useScreenInit();
  // Meta Pixel — safely injected in a useEffect, wrapped in try/catch so any
  // failure here can never crash the React tree.
  useEffect(() => {
    try {
      if (typeof window === 'undefined' || typeof document === 'undefined') return;
      const w = window as any;
      if (w.__fbPixelInited === META_PIXEL_ID) return;
      // Skip if the fbevents script tag already exists
      const existing = document.querySelector('script[src*="connect.facebook.net/en_US/fbevents.js"]');
      const initPixel = () => {
        try {
          if (typeof w.fbq === 'function') {
            w.fbq('init', META_PIXEL_ID);
            w.fbq('track', 'PageView');
            w.__fbPixelInited = META_PIXEL_ID;
          }
        } catch (_) {
          /* swallow */
        }
      };
      if (existing) {
        initPixel();
        return;
      }
      // Stub queue so calls before script loads are buffered
      if (!w.fbq) {
        const stub: any = function () {
          stub.callMethod ? stub.callMethod.apply(stub, arguments) : stub.queue.push(arguments);
        };
        stub.push = stub;
        stub.loaded = true;
        stub.version = '2.0';
        stub.queue = [];
        w.fbq = stub;
        w._fbq = stub;
      }
      const script = document.createElement('script');
      script.async = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      script.onload = initPixel;
      script.onerror = () => {
        /* swallow network errors */
      };
      document.head.appendChild(script);
      // Fire init/PageView immediately too — fbq queue will buffer until loaded
      initPixel();
    } catch (_) {
      /* never crash the app for a tracking script */
    }
  }, []);
  return <div className="min-h-screen bg-[#0a0a0a] text-[#e8e2d4] font-sans selection:bg-[#d4a85a]/30 selection:text-white" data-id="element-0">
      <UrgencyBar data-id="element-1" />
      <SocialProofToast data-id="element-2" />

      <main data-id="element-3">
        <Hero data-id="element-4" />
        <Manifesto data-id="element-5" />
        <WhyReadThis data-id="element-6" />
        <FiveReasonsHeader data-id="element-7" />
        <WhatYouLearn data-id="element-8" />
        <Dedication data-id="element-9" />
        <WarningSection data-id="element-10" />
        <BookExcerpts data-id="element-11" />
        <Testimonials data-id="element-12" />
        <FourReasons data-id="element-13" />
        <PricingGuarantee data-id="element-14" />
        <FAQ data-id="element-15" />
      </main>

      <Footer data-id="element-16" />

      {/* Noscript fallback for Meta Pixel */}
      <noscript data-id="element-17">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-18" />
      </noscript>
    </div>;
}